<template>
  <loadable-content>
    <worksheet-form />
  </loadable-content>
</template>

<script>
  import { WorksheetsService } from '@autoinformer/services/WorksheetsService';
  // import { CampaignsService } from '@autoinformer/services/CampaignsService';
  import WorksheetForm from '@autoinformer/components/worksheets/form';
  import { mapActions } from 'vuex';

  export default {
    components: { WorksheetForm },
    created() {
      const id = this.$route.params.id;

      WorksheetsService.getScheme(id)
        .then((res) => {          
          return Promise.all([
            this.setCampaignId(id),
            this.setId(res.id),
            this.setActions(res.items),
            this.setLastSaveActions(res.items)
          ]);
        })
        .catch((e) => this.showPageError(e))
        .finally(() => this.endLoadingPage());
    },

    methods: {
      ...mapActions('autoinformer/worksheets/form', ['setId', 'setCampaignId', 'setActions', 'setLastSaveActions'])
    }
  };
</script>
